import { generateLabelAndValuesVariant } from "../utils/HelperFunctions";

export const ATP_PROFILE_STATUS_CONSTANT = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
};

export const ATP_TABS = [
    {
        name: "Pending Approval",
        type: ATP_PROFILE_STATUS_CONSTANT.PENDING,
    },
    {
        name: "Active",
        type: ATP_PROFILE_STATUS_CONSTANT.APPROVED,
    },
    {
        name: "Rejected",
        type: ATP_PROFILE_STATUS_CONSTANT.REJECTED,
    },
];

export const OrgTypeNames = [
    "Company registered or incorporated under Suruhanjaya Syarikat Malaysia (SSM)",
    "Association/ NGO",
    "Industry-based Training Centre",
    "Cooperatives registered under Suruhanjaya Koperasi Malaysia",
    "Government/ Semi-Government Institution",
];

export const orgEnum = {
    COMPANY_SSM: 1,
    ASSOCIATION_NGO: 2,
    INDUSTRY_BASED_TRAINING_CENTRE: 3,
    COOPERATIVES_KOPERASI: 4,
    GOVERNMENT_SEMI_GOVERNMENT_INSTITUTION: 5,
};

export const OrgTypeLabelAndValues = generateLabelAndValuesVariant({
    enums: orgEnum,
    labels: OrgTypeNames,
});
